import {forwardRef, useEffect, useState} from "react";
import {Box, Button, Dialog, Slide, Typography, useMediaQuery} from "@mui/material"
import {TransitionProps} from "@mui/material/transitions";
import {useTranslation} from "react-i18next";

import {ILogoutDialogProps, styles} from './logoutDialog-helpers';
import CloseIcon from '../../../../assets/images/svgs/close.svg';
import {useAppContext, useAuth} from "../../../../contexts";
import TranslationMsg from '../../transMessage';
import {theme} from "../../../../utils";

const DialogTransition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const LogoutDialogBox = (props: ILogoutDialogProps) => {
    const {showDialog, onCloseLogout} = props
    const {t} = useTranslation();
    const {logout} = useAuth();
    const {userData} = useAppContext()
    const isMobileX = useMediaQuery(theme.breakpoints.down(400))

    const [openLogoutDialog, setOpenLogoutDialog] = useState(showDialog);

    const emailId = userData?.emails?.find((mail: any) => mail?.isPrimary)?.email

    useEffect(() => {
        if (showDialog) {
            setOpenLogoutDialog(showDialog)
        }
    }, [showDialog])

    const handleDialogClose = () => {
        setOpenLogoutDialog(false);
        if (onCloseLogout) {
            onCloseLogout()
        }
    };

    const handleLogOut = () => {
        logout()
        handleDialogClose()
    };

    return (
        <Dialog
            open={openLogoutDialog}
            onClose={handleDialogClose}
            slots={{transition: DialogTransition}}>
            <Box display={"flex"} flexDirection={"column"} sx={{backgroundColor: "#fff", borderRadius: "8px"}}
                 textAlign={'center'}>
                <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} flex={1}
                     sx={{pl: "20px", pr: "24.5px", pt: "20px"}}>
                    <Typography sx={styles.dialogTitle}>{t(TranslationMsg.LOGOUT_DIALOG_TITLE)}</Typography>
                    <Box onClick={handleDialogClose} sx={{cursor: "pointer"}}>
                        <img src={CloseIcon} alt="close-icon"/>
                    </Box>
                </Box>
                <Box flex={1}>
                    <Typography
                        sx={[styles.dialogSubTitle, {mx: isMobileX ? "10px" : "70px"}]}>{t(TranslationMsg.LOGOUT_DESCRIPTION)} {emailId}</Typography>
                </Box>
                <Box display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={'center'}
                     flexWrap={"wrap"} mt={'33px'} mb="24px" gap={'16px'} sx={{pl: "75px", pr: "75px"}}>
                    <Button
                        variant='outlined'
                        onClick={handleDialogClose}
                        sx={[styles.rowAlignBtnWrapper, {border: "1px solid #404144"}]}>
                        <Typography
                            sx={{...theme.typography.components.montseratButtonOutlinedLabel}}>
                            {t(TranslationMsg.CANCEL_AND_STAY_BTN_LABEL)}
                        </Typography>
                    </Button>

                    <Button
                        variant='contained'
                        onClick={handleLogOut}
                        sx={styles.rowAlignBtnWrapper}>
                        <Typography
                            sx={{...theme.typography.components.montseratButtonContainedLabel}}>
                            {t(TranslationMsg.LOGOUT_BTN_LABEL)}
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </Dialog>
    )
}